var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMobileSymbol(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 23,
    viewBox: "0 0 14 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2255_1360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5728 5.87793C9.57059 5.87809 6.30811 8.34828 6.30811 11.373V22.667H3.13818V11.373C3.13818 6.59148 7.81379 2.70819 13.5728 2.70801V5.87793ZM13.5728 0.52832C10.3631 0.528405 7.29835 1.5585 4.96045 3.4209C2.42439 5.46829 0.958496 8.36143 0.958496 11.373H0.430176C0.430176 8.20295 1.96226 5.15158 4.63037 3.01172C7.06074 1.07007 10.2442 8.51757e-05 13.5728 0V0.52832Z",
    fill: "#1B1F38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5262 13.4072C12.7299 13.4072 13.7057 12.4314 13.7057 11.2277C13.7057 10.024 12.7299 9.04822 11.5262 9.04822C10.3225 9.04822 9.34668 10.024 9.34668 11.2277C9.34668 12.4314 10.3225 13.4072 11.5262 13.4072Z",
    fill: "#85F2A6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2255_1360"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.7054,
    height: 22.6667,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMobileSymbol);
export default __webpack_public_path__ + "static/media/ic_mobile_symbol.be184963eafd52a5af358430f4eda1cb.svg";
export { ForwardRef as ReactComponent };